<template>
  <Card class="shadow mb-3">
    <div>
      <div class="d-flex align-items-center">
        <div>
          <div class="small font-weight-bold text-muted">{{ $t('PalCard.title') }}</div>
          <h6 class="h4 text-body line-height-1 mt-1 mb-0">
            {{ $n(palMaxAmount, 'currencyNoDecimals') }}
          </h6>
        </div>
        <div class="flex-grow-1"></div>
        <router-link :to="{name: 'scan'}"
                     class="btn btn-primary btn-xs rounded-pill btn-with-icon text-white">
          <Icon icon-name="qr-code" icon-class="icon-xs mr-1"></Icon>
          <span>{{ $t('PalCard.btn.qr') }}</span>
        </router-link>
      </div>
    </div>

    <div class="mt-1 mx-n3 list-group-flush mb-n3">
      <router-link :to="{name: 'pal-partners'}"
                   class="list-group-item list-group-item-with-icon">
        <div class="d-flex avatar justify-content-center mr-2 align-items-center">
          <Icon icon-name="star-outline" icon-class="icon text-primary mr-0 align-self-center"></Icon>
        </div>
        <div class="d-inline-flex align-items-center font-weight-bolder">
          {{ $t('PalCard.btn.shop') }}
        </div>
        <div class="flex-grow-1"></div>
        <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"/>
      </router-link>

      <router-link :to="{name: 'new-loan'}" class="list-group-item list-group-item-with-icon">
        <div class="d-flex avatar justify-content-center mr-2 align-items-center">
        <Icon icon-name="banknotes-outline" icon-class="icon text-primary mr-0 align-self-center"></Icon>
        </div>
        <div class="d-inline-flex align-items-center font-weight-bolder">
          {{ $t('PalCard.btn.cash') }}
        </div>
        <div class="flex-grow-1"></div>
        <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"/>
      </router-link>
    </div>
  </Card>
</template>

<script>
import Icon from '@shared/components/Icon'
import Card from '@shared/components/Card'

export default {
  components: {
    Card,
    Icon
  },
  props: ['palMaxAmount']
}
</script>
